import { Store } from '@betgames/bg-state-manager';
import { storageRepository } from '@betgames/bg-tools';
import { StoresEntity } from '@bg-shared/business/StoreFeature';
import { GameId } from '@bg-shared/enums/GameId';
import currency from 'currency.js';

const STORAGE_KEY = 'betAmount_';

export const betAmountEntity = new StoresEntity(
    class BetAmount extends Store<number> {
        private readonly storageKey: string;

        constructor(private readonly gameId: GameId) {
            super({
                key: `BetAmount/${gameId}`,
                default: 0,
            });

            this.storageKey = `${STORAGE_KEY}${this.gameId}`;
        }

        public init(inputAmountSequence: number[], exactAmount = false): void {
            const storageAmount = currency(storageRepository.getItem(this.storageKey)).value;

            if (Number.isNaN(storageAmount)) {
                if (!inputAmountSequence.length) {
                    return;
                }

                this.update(inputAmountSequence[0]);
                return;
            }

            if (!inputAmountSequence.length) {
                this.update(storageAmount);
                return;
            }

            const validAmount = inputAmountSequence.some((amount) =>
                exactAmount ? amount === storageAmount : amount >= storageAmount,
            );

            if (validAmount) {
                this.update(storageAmount);
            } else {
                this.update(inputAmountSequence[0]);
            }
        }

        public update(value: number) {
            super.update(value);

            storageRepository.setItemParsed(this.storageKey, value);
        }
    },
);
